/**
 * Schermteksten in het Arabisch.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const ar: Teksten = {
  kamerOphalen: "جاري جلب الغرفة…",
  kamerWerktNiet: "هذه الغرفة لا تعمل",
  serverReageertNiet: "الخادم لا يستجيب",
  probeerOpnieuw: "جرّب مجدداً",
  vraagNieuweCode: "اطلب رمزاً جديداً من الشخص الذي شارك الرمز معك. تنتهي صلاحية الغرفة بعد بضع ساعات.",
  welkeTaalSprekJij: "ما هي لغتك؟",
  jouwStem: "صوتك في الترجمة",
  man: "رجل",
  vrouw: "امرأة",
  pincode: "رمز PIN",
  pincodeUitleg: "تحصل عليه من الشخص الذي شارك الرمز معك.",
  gaDeKamerIn: "ادخل الغرفة",
  kiesEerstJeTaal: "اختر لغتك أولاً",
  microfoonAanvragen: "جاري طلب الميكروفون…",
  toestemmingUitleg: "سيطلب متصفحك الآن إذناً لاستخدام الميكروفون. بدون ذلك، يمكنك الكتابة فقط.",
  microfoonTestLink: "اختبر الميكروفون أولاً",
  stemGaatMee: "في هذه الغرفة، يسمع الطرف الآخر صوتك الأصلي أيضاً بالإضافة إلى الترجمة.",
  alleenChatMelding: "هذه المحادثة دردشة فقط. تكتب رسائلك وتقرأ الترجمة؛ لا يُقرأ شيء بصوت عالٍ.",
  verlooptOm: "تنتهي الصلاحية الساعة",
  nooitVasteKamer: "أبداً، غرفة دائمة",
  kamer: "غرفة",
  tolkgesprek: "محادثة ترجمة فورية",
  juisteKamer: "أنت في الغرفة الصحيحة. ستتمكن من المشاركة في الحديث قريباً.",
  jij: "أنت",
  deAnder: "الطرف الآخر",
  verbinden: "جاري الاتصال…",
  verbonden: "متصل",
  verbindingKwijt: "انقطع الاتصال. جاري إعادة المحاولة…",
  wachtenOpAnder: "لقد دخلت. بانتظار مسح الطرف الآخر لرمز QR.",
  allebeiInDeKamer: "كلاكما في الغرفة الآن.",
  anderIsWeg: "غادر الطرف الآخر",
  anderSpreekt: "الطرف الآخر يتحدث…",
  jeKuntErNietIn: "لا يمكنك الدخول",
  overgenomenTitel: "المتابعة على جهاز آخر",
  overgenomenUitleg: "تم فتح هذه المحادثة للتو على جهاز آخر. يمكنك المتابعة من هناك.",
  terug: "رجوع",
  geluidStaatUit: "الصوت مكتوم. اضغط في أي مكان على الشاشة.",
  tikHier: "اضغط هنا",
  bewaardTot: 'محفوظ حتى {tijd}',
  bewaardVast: "غرفة دائمة. تُحفظ الرسائل لمدة 30 يوماً.",
  spreekIn: "تحدّث",
  luisteren: "استماع… اضغط للإيقاف",
  uitschrijven: "جاري نسخ الصوت…",
  tijdOmTeVerbeteren: "وقت التصحيح",
  altijdZelfVersturen: "مراجعة وإرسال يدوي دائماً",
  jijVerstuurtZelf: "أنت ترسل بنفسك",
  uit: "إيقاف",
  sec: "ثانية",
  vertalingMeteenAfspelen: "تشغيل الترجمة فوراً",
  typHierJeBericht: "اكتب رسالتك هنا…",
  stuur: "إرسال",
  geenOpnameMogelijk: "لا يمكن لهذا المتصفح تسجيل الصوت. يمكنك الكتابة بدلاً من ذلك.",
  verstaanAls: "فُهِم على أنه",
  tellerStaatStil: "العداد متوقف",
  versturen: "إرسال",
  wis: "مسح",
  jijZei: "قلتَ",
  vertaald: "مترجم",
  duimOmhoog: "هذا صحيح",
  duimOmlaag: "هذا غير صحيح",
  opnieuwProberenKnop: "إعادة المحاولة بنموذج أفضل",
  opnieuwProberenBezig: "جاري إعادة الترجمة…",
  duimTranscriptWoordenlijstUitnodiging: "هل فُهمت الكلمة خطأ؟ صححها في قائمة الكلمات:",
  instellingenAanpassen: "تعديل الإعدادات",
  geldtVoorJullieBeiden: "ينطبق على كلاكما",
  alleenVoorJou: "لك فقط",
  stuurMijnStemMee: "أرسل صوتي الأصلي أيضاً",
  verbeterSpelfouten: "تصحيح الأخطاء الإملائية في نصي",
  verbeterSpelfoutenUit: "عند الإيقاف، سيظهر ما سُمع بدقة، بما في ذلك الأخطاء.",
  alleenChat: "دردشة فقط: بدون صوت، بدون ميكروفون",
  alleenChatUitleg: "كلاكما يكتب. تظهر الترجمة والنص الأصلي؛ لا يُقرأ شيء بصوت عالٍ.",
  aangepastDoorDeAnder: "قام الطرف الآخر بتغيير الإعدادات.",
  foutSpraak: "الترجمة النصية جاهزة، ولكن لم يصدر صوت.",
  foutSpraakQuota: "نفد رصيد الصوت لهذا اليوم. يستمر النص في العمل بشكل طبيعي؛ سيعود الصوت غداً.",
  foutBudgetKamer: "وصلت هذه المحادثة إلى حدّها، لذلك توقفت الترجمة مؤقتاً. يمكن لمن أنشأ المحادثة رفع الحد، وبعدها تعمل الترجمة فوراً من جديد.",
  foutBudgetMaand: "نفدت الميزانية الشهرية للتطبيق. ستعود الترجمة للعمل عندما يعدّلها المسؤول.",
  foutTaal: "هذه اللغة غير ممكنة: لا يمكن لكما التحدث بنفس اللغة.",
  origineel: "الأصل",
  vertalen: "جاري الترجمة…",
  vertalenMislukt: "فشلت الترجمة.",
  opnieuwAfspelen: "إعادة تشغيل الترجمة",
  hoorDeAnder: "استمع كيف قالها الطرف الآخر بنفسه",
  woordenlijst: "قائمة كلمات التصحيح",
  woordenlijstUitleg: "هل يفهم التطبيق اسماً أو مصطلحاً بشكل خاطئ دائماً؟ حدد المعنى الصحيح هنا.",
  hijHoort: "يسمع…",
  jijBedoelt: "تقصد…",
  ookVolgendeGesprekken: "في المحادثات القادمة أيضاً — وإلا فسينطبق هنا فقط",
  voegToe: "إضافة",
  bezig: "جاري العمل…",
  lijstNietGeladen: "تعذر تحميل القائمة.",
  toevoegenMislukt: "فشلت الإضافة.",
  verwijderenMislukt: "فشل الحذف.",
  overal: "في كل مكان",
  verwijder: "حذف",
  overDitGesprek: "حول هذه المحادثة",
  toon: "نبرة الترجمة",
  sfeer: "أجواء المحادثة",
  jouwPlek: "موقعك",
  hoeHetWerkt: "يقوم الخادم بنسخ تسجيلك وترجمته دفعة واحدة. يُرسل صوتك الأصلي أيضاً إلى الطرف الآخر.",
  kleinereTekst: "نص أصغر",
  grotereTekst: "نص أكبر",
  insprekenVerbergen: "إخفاء التحدث",
  insprekenTonen: "إظهار التحدث",
  toetsenbordVerbergen: "إخفاء لوحة المفاتيح",
  toetsenbordTonen: "إظهار لوحة المفاتيح",
  vormAutomatisch: "تلقائي",
  vormInformeel: "غير رسمي",
  vormFormeel: "رسمي",
  sfeerNeutraal: "محايد",
  sfeerZakelijk: "عملي",
  sfeerOfficieel: "رسمي",
  sfeerVriendschappelijk: "ودي",
  sfeerPartner: "شريك",
  foutKamerVol: "هذه الغرفة ممتلئة. يمكن لشخصين فقط الدخول.",
  plekBezetTitel: "مكانك مشغول",
  plekBezetUitleg: "يوجد شخص بالفعل في جانبك من هذه المحادثة، بلغتك. في الغالب هذا أنت: المحادثة ما زالت مفتوحة على جهاز آخر أو في علامة تبويب أخرى. أغلقها هناك وحاول مرة أخرى. قد يستغرق تحرير المكان دقيقة ونصفًا.",
  plekBezetWissel: "هل هذا أنت؟ اكتب WISSEL لنقل المحادثة إلى هذا الجهاز. سيُغلق الجهاز الآخر عندها.",
  plekBezetKnop: "انقل إلى هذا الجهاز",
  foutKamerVerlopen: "انتهت صلاحية هذه الغرفة أو تم إغلاقها.",
  foutKamerOnbekend: "هذه الغرفة غير موجودة.",
  foutPinNodig: "تتطلب هذه الغرفة رمز PIN.",
  foutPinFout: "رمز PIN غير صحيح.",
  foutProtocol: "لا يوجد توافق بين التطبيق والخادم. يرجى تحديث الصفحة.",
  foutMicroGeweigerd: "لقد رفضت إذن الميكروفون. انقر على القفل في شريط العنوان وقم بتفعيله.",
  foutGeenMicro: "لم يتم العثور على ميكروفون. قم بتوصيل واحد وحاول مجدداً.",
  foutMicroInGebruik: "الميكروفون مستخدم من قِبل برنامج آخر. أغلقه وحاول مجدداً.",
  foutGeenHttps: "يعمل الميكروفون فقط عبر اتصال آمن. افتح هذه الصفحة عبر https.",
  foutMicroOnbekend: "تعذر تشغيل الميكروفون.",
  foutNietsOpgenomen: "لم يتم تسجيل أي شيء. هل الميكروفون قيد التشغيل؟",
  foutNietsGehoord: "لم يُسمع شيء. هل الميكروفون قيد التشغيل وهل تتحدث بصوت عالٍ كافٍ؟",
  foutOpnameTeLang: "التسجيل طويل جداً. تحدث في مقاطع أقصر.",
  foutMicroGedempt: "الميكروفون مكتوم. قم بتفعيله وحاول مجدداً.",

  // --- microfoontest ---
  micTitel: "اختبار الميكروفون",
  micOnderschrift: "أربعة اختبارات متتالية، كل واحد خمس ثوانٍ. استمر في الكلام طوال الوقت.",
  micStart: "ابدأ الاختبار",
  micTest1: "١. التعرّف فقط",
  micTest2: "٢. التسجيل فقط",
  micTest3: "٣. معًا — التسجيل أولاً",
  micTest4: "٤. معًا — التعرّف أولاً",
  micFase1: "١ من ٤: التعرّف فقط — قل جملة قصيرة",
  micFase2: "٢ من ٤: التسجيل فقط — واصل الكلام",
  micFase3: "٣ من ٤: التسجيل أولاً ثم التعرّف — واصل الكلام",
  micFase4: "٤ من ٤: التعرّف أولاً ثم التسجيل — واصل الكلام",
  micKlaar: "انتهى",
  micGehoord: "المسموع",
  micOpnameformaat: "صيغة التسجيل",
  micGeen: "لا شيء",
  micBeveiligd: "اتصال آمن",
  micJa: "نعم",
  micNee: "لا",
  micBrowser: "المتصفح",
  micGeenHttps: "بدون https لا يتيح المتصفح الميكروفون. على localhost مسموح.",
  micGeenHerkenning: "هذا المتصفح لا يدعم التعرّف على الكلام.",
  micZegIets: "قل شيئًا…",
  micWoordenBinnen: "الكلمات تصل",
  micKonNietStarten: "تعذّر البدء",
  micGeenRecorder: "هذا المتصفح لا يعرف MediaRecorder.",
  micOpnemen: "جارٍ التسجيل…",
  micNietsOpgenomen: "لم يُسجَّل شيء",
  micGeenMicrofoon: "لا يوجد ميكروفون",
  micOpnameEerst: "التسجيل أولاً…",
  micHerkenningEerst: "التعرّف أولاً…",
  micOpnameStarttNiet: "لم يبدأ التسجيل",
  micSamenGelukt: "معًا. التسجيل {kb} كيلوبايت.",
  micAlleenOpname: "التسجيل نعم، التعرّف لا.",
  micAlleenHerkenning: "التعرّف نعم، التسجيل لا.",
  micGeenVanBeide: "لا هذا ولا ذاك.",
  micNetwerkFout: "تعذّر على التعرّف على الكلام الوصول إلى الخادم.",
  micAfgebroken: "تم إيقاف التسجيل.",
  verslagTitel: "محضر المحادثة",
  verslagWie: "من",
  verslagOrigineel: "الأصل",
  verslagVertaling: "الترجمة",
  verslagSpreker: "المتحدث {x}",
  verslagBerichten: "الرسائل",
  verslagGemaaktOp: "تاريخ الإنشاء",
  verslagGeenOpname: "ليس تسجيلًا حرفيًا.",
  verslagNootOrigineel: "«الأصل» هو النص كما فهمه التطبيق من المتحدث.",
  verslagNootCorrectie: "كان التصحيح الإملائي مفعّلًا: تم تصحيح أخطاء الكتابة البسيطة.",
  verslagNootAangepast: "كان بإمكان المتحدث تعديل النص قبل إرساله.",
  verslagGesproken: "منطوق",
  verslagGetypt: "مكتوب",
  verslagMislukt: "فشلت الترجمة. لم يرَ الطرف الآخر هذه الجملة بلغته.",
  verslagNietKlaar: "لم تكن الترجمة جاهزة بعد عند إنشاء هذا المحضر.",
  verslagVertrouwelijk: "سرّي.",
  verslagAlleenDeelnemers: "يحتوي هذا المحضر على مضمون محادثة خاصة وهو مخصص للمشاركين فقط.",
  verslagGewist: "موعد حذف المحادثة: {tijd}. بعد ذلك لا يمكن إنشاء هذا المحضر مرة أخرى.",
  verslagGewistVast: "غرفة دائمة: تُحذف كل رسالة بعد 30 يوماً من إرسالها. الرسائل الأقدم غير موجودة في هذا المحضر.",
};
